/*
    author: Patrick Vyn Badiang

    description:
    Is the mean header of the page, does not change
*/
import FasaImg from '../pictures/FasaLogo.png';
import { Typography, Box, AppBar, Toolbar, Button, ButtonGroup, Avatar, useScrollTrigger, Link, useMediaQuery } from "@mui/material";
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import MainMenu from './MainMenu';
import { mustard } from '../styles.tsx';

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };

const MainHeader = (props) => {

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const location = useLocation();
  const activeColor = (path) => (location.pathname === path ? mustard : 'inherit');

    return (
        <Box>
            <HideOnScroll {...props}>
            
            
            <AppBar sx = {{
              marginBottom: '5px',
              height: {
                  xs: '78px',   // Extra-small devices (phones)
                  sm: '76px', // Small devices (tablets)
                  md: '90px',   // Medium devices (desktops)
                  lg: '100px',   // Large devices (large desktops)
              }
          }}>
              <Toolbar sx = {{
                  height: '100%'
              }}>
                  <Avatar
                      component={Link}
                      href="/"
                      src = {FasaImg}
                      sx = {{
                          width: {
                              xs: '44px',   // Extra-small devices (phones)
                              sm: '48px', // Small devices (tablets)
                              md: '52px',   // Medium devices (desktops)
                              lg: '56px',   // Large devices (large desktops)
                          },
                          height: {
                              xs: '44px',   // Extra-small devices (phones)
                              sm: '48px', // Small devices (tablets)
                              md: '52px',   // Medium devices (desktops)
                              lg: '56px',   // Large devices (large desktops)
                          },
                          marginRight: '12px'
                      }}/>
                      <Typography
                      component= {Link}
                      href = "/"
                      variant="h3"
                      fontWeight={'bold'}
                      sx = {{
                          fontSize: {
                              xs: '1.5rem',   // Extra-small devices (phones)
                              sm: '1.6rem', // Small devices (tablets)
                              md: '2rem',   // Medium devices (desktops)
                              lg: '2.4rem',   // Large devices (large desktops)
                            },
                          flexGrow: 1,
                          color: 'inherit',
                          textDecoration: 'none',
                          '&:hover': {
                          },
                      }}>{props.text}
                  </Typography>
                  
                  {isSmallScreen ? (
                    <ButtonGroup 
                    variant = 'contained' disableElevation
                    aria-label="outlined primary button group">
                    <MainMenu/>
                    </ButtonGroup>
                    
                  ) : (
                    <ButtonGroup 
                      variant = 'contained' disableElevation
                      aria-label="outlined primary button group">
                      
                      <Button href = "/"
                          sx={{ my: 2, color: 'white', display: 'block' }}>

                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/'),}} >
                          Home
                          </Typography>

                      </Button>
                      <Button href = "/board"
                          sx={{ my: 2, color: 'white', display: 'block' }}>

                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/board'),}}>
                          Board
                          </Typography>
                      </Button>
                      {/* <Button href = "/memberHighlight"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)
                              
                            },}} >
                          Member Highlight
                          </Typography>  
                        </Button> */}
                      <Button href = "/resources"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/resources'),}} >
                          Resources
                          </Typography>
                      </Button>
                      <Button href = "/constitution"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/constitution'),}} >
                          Constitution
                          </Typography>
                      </Button>
                      {/* <Button href = "/donation"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)
                              
                            },}} >
                          Donate Now
                          </Typography>                                 
                      </Button> */}
                      <Button href = "/scholarship"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/scholarship'),}} >
                          Scholarship
                          </Typography>
                      </Button>
                      <Button href = "/links"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/links'),}} >
                          Links
                          </Typography>
                      </Button>
                      <Button href = "/gallery"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/gallery'),}} >
                          Gallery
                          </Typography>
                      </Button>
                      <Button href = "/ate-kuya"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/ate-kuya'),}} >
                          Ate/Kuya
                          </Typography>
                      </Button>
                      <Button href = "/calendar"
                          sx={{ my: 2, color: 'white', display: 'block' }}>
                          <Typography variant = "h6" fontWeight={'bold'}
                          sx = {{fontSize: {
                              xs: '0.8rem',   // Extra-small devices (phones)
                              sm: '0.85rem', // Small devices (tablets)
                              md: '0.95rem',   // Medium devices (desktops)
                              lg: '1.35rem',   // Large devices (large desktops)

                            }, color: activeColor('/calendar'),}} >
                          Calendar
                          </Typography>
                      </Button>

                  </ButtonGroup>

                  )}

                  
              </Toolbar>
          </AppBar>
                
            
            </HideOnScroll>
        </Box>

    );

}

export default MainHeader;